import { useEffect } from "react";
import { t } from "@/lib/i18n";
import { useSite } from "@/context/SiteContext";

export default function ExternalRedirect({ target }) {
  const { content } = useSite();
  const url = target === "partner" ? content.partner_app_url : content.consumer_app_url;
  useEffect(() => { window.location.replace(url); }, [url]);
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-[var(--paper)]" data-testid="external-redirect">
      <img src="/logo-round-320.png" alt={t("Kindsaver")} className="w-20 h-20" />
      <p className="text-sm text-[var(--ink-soft)]">{t("Taking you to the Kindsaver app…")}</p>
      <a href={url} className="btn-leaf text-sm" data-testid="external-redirect-link">{t("Continue")}</a>
    </div>
  );
}
